import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FirstPersonControls } from 'three/examples/jsm/controls/FirstPersonControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import * as dat from 'lil-gui'
import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls'
import * as TWEEN from 'tween/tween.js'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { DotScreenPass } from 'three/examples/jsm/postprocessing/DotScreenPass.js'
import { HalftonePass } from 'three/examples/jsm/postprocessing/HalftonePass.js'
import { TextureLoader } from 'three'

THREE.ColorManagement.enabled = false

/**
 * Base
 */
// Debug
const gui = new dat.GUI()

const pointLightFolder = gui.addFolder('Point Light')
const folder3 = gui.addFolder('DotScreenPass')
const folder4 = gui.addFolder('HalftonePass')
const folder2 = gui.addFolder('Fog')
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(0x000000);

const fog = new THREE.Fog('#000000', 300, 1000)


folder2.add(fog, 'near').name('Fog-near').min(0).max(800).step(0.001)
folder2.add(fog, 'far').name('Fog-far').min(0).max(800).step(0.001)
folder2.addColor(fog, 'color').name('Fog-color')

scene.fog = fog

// 创建两个层
const layer1 = new THREE.Layers();
const layer2 = new THREE.Layers();
layer1.set(0); // 设置层0
layer2.set(1); // 设置层1

/**
 * Update all materials
    */
const updateAllMaterials = () =>
{
    scene.traverse((child) =>
    {
        if(child.isMesh && child.material.isMeshStandardMaterial)
        {
            // ...
            
            child.castShadow = true
            child.receiveShadow = true
        }
    })
}
/**
 * Models
 */

const gltfLoader = new GLTFLoader()


// Remove the existing declaration of gltfLoader


gltfLoader.load(
    '/models/room/roof.gltf',
    (gltf) => {
        const model = gltf.scene.children[0]
        model.scale.set(0.1, 0.1, 0.1)
        model.position.set(0, 0, 0)
        model.castShadow = true
        model.receiveShadow = true
        // Create a texture loader
        const textureLoader = new THREE.TextureLoader()

        // Define the image sequence URLs
        const imageSequenceUrls = [
            '/models/transprant/trans_00020.jpg',
            '/models/transprant/trans_00021.jpg',
            '/models/transprant/trans_00022.jpg',
            '/models/transprant/trans_00023.jpg',
            '/models/transprant/trans_00024.jpg',
            '/models/transprant/trans_00025.jpg',
            '/models/transprant/trans_00026.jpg',
            '/models/transprant/trans_00027.jpg',
            '/models/transprant/trans_00028.jpg',
            '/models/transprant/trans_00029.jpg',
            '/models/transprant/trans_00030.jpg',
            '/models/transprant/trans_00031.jpg',
            '/models/transprant/trans_00032.jpg',
            '/models/transprant/trans_00033.jpg',
            '/models/transprant/trans_00034.jpg',
            '/models/transprant/trans_00035.jpg',
            '/models/transprant/trans_00036.jpg',
            '/models/transprant/trans_00037.jpg',
            '/models/transprant/trans_00038.jpg',
            '/models/transprant/trans_00039.jpg',
            '/models/transprant/trans_00040.jpg',
            '/models/transprant/trans_00041.jpg',
            '/models/transprant/trans_00042.jpg',
            '/models/transprant/trans_00043.jpg',
            '/models/transprant/trans_00044.jpg',
            '/models/transprant/trans_00045.jpg',
            '/models/transprant/trans_00046.jpg',
            '/models/transprant/trans_00047.jpg',
            '/models/transprant/trans_00048.jpg',
            '/models/transprant/trans_00049.jpg',
            '/models/transprant/trans_00050.jpg',
            '/models/transprant/trans_00051.jpg',
            '/models/transprant/trans_00052.jpg',
            '/models/transprant/trans_00053.jpg',
            '/models/transprant/trans_00054.jpg',
            '/models/transprant/trans_00055.jpg',
            '/models/transprant/trans_00056.jpg',
            '/models/transprant/trans_00057.jpg',
            '/models/transprant/trans_00058.jpg',
            '/models/transprant/trans_00059.jpg',
            '/models/transprant/trans_00060.jpg',
            '/models/transprant/trans_00061.jpg',
            '/models/transprant/trans_00062.jpg',
            '/models/transprant/trans_00063.jpg',
            '/models/transprant/trans_00064.jpg',
            '/models/transprant/trans_00065.jpg',
            '/models/transprant/trans_00066.jpg',
            '/models/transprant/trans_00067.jpg',
            '/models/transprant/trans_00068.jpg',
            '/models/transprant/trans_00069.jpg',
            '/models/transprant/trans_00070.jpg',
            '/models/transprant/trans_00071.jpg',
            '/models/transprant/trans_00072.jpg',
            '/models/transprant/trans_00073.jpg',
            '/models/transprant/trans_00074.jpg',
            '/models/transprant/trans_00075.jpg',
            '/models/transprant/trans_00076.jpg',
            '/models/transprant/trans_00077.jpg',
            '/models/transprant/trans_00078.jpg',
            '/models/transprant/trans_00079.jpg',
            '/models/transprant/trans_00080.jpg',
            '/models/transprant/trans_00081.jpg',
            '/models/transprant/trans_00082.jpg',
            '/models/transprant/trans_00083.jpg',
            '/models/transprant/trans_00084.jpg',
            '/models/transprant/trans_00085.jpg',
            '/models/transprant/trans_00086.jpg',
            '/models/transprant/trans_00087.jpg',
            '/models/transprant/trans_00088.jpg',
            '/models/transprant/trans_00089.jpg',
            '/models/transprant/trans_00090.jpg',
            '/models/transprant/trans_00091.jpg',
            '/models/transprant/trans_00092.jpg',
            '/models/transprant/trans_00093.jpg',
            '/models/transprant/trans_00094.jpg',
            '/models/transprant/trans_00095.jpg',
            '/models/transprant/trans_00096.jpg',
            '/models/transprant/trans_00097.jpg',
            '/models/transprant/trans_00098.jpg',
            '/models/transprant/trans_00099.jpg',
            '/models/transprant/trans_00100.jpg',

            
            // Add more image URLs as needed
        ]

        // Create an array to store the textures
        const textures = []
        // Color Texture
        const roofcolorTexture = textureLoader.load('/Terrazzo008_2K-JPG_Color.png');
        // Load the image sequence textures
        imageSequenceUrls.forEach((imageUrl) => {
            const Alphatexture = textureLoader.load(imageUrl)
            textures.push(Alphatexture)
        })

        // Create a material using the image sequence textures
        const material = new THREE.MeshStandardMaterial()
        material.transparent = true
        material.alphaMap = textures[0]
        material.color = new THREE.Color('#a3a3a3')
        
        material.map = roofcolorTexture
        material.map.repeat.x = 10
        material.map.repeat.y = 10
        material.map.wrapS = THREE.RepeatWrapping
        material.map.wrapT = THREE.RepeatWrapping
        material.depthWrite = false
        model.traverse((child) => {
            if (child.isMesh) {
                // 移除原始材质
                child.material = material
            }
        });
        

        // Create a mesh using the model and material
        const mesh = new THREE.Mesh(model.geometry, material)
        mesh.castShadow = true
        mesh.receiveShadow = true
        mesh.position.set(-230, 0, 70)
        mesh.scale.set(0.35, 0.35, 0.35)
        mesh.renderOrder = 1
        scene.add(mesh)
        
        // Animation variables
        let currentFrame = 0
        const frameRate = 30 // Number of frames per second
        const frameDuration = 1000 / frameRate // Duration of each frame in milliseconds

        // Function to update the texture frame
        const updateTextureFrame = () => {
            //material.map = textures[currentFrame]
            material.alphaMap = textures[currentFrame]
            material.needsUpdate = true
            currentFrame = (currentFrame + 1) % textures.length
        }

        // Start the animation loop
        const animate = () => {
            setTimeout(() => {
                requestAnimationFrame(animate)
                updateTextureFrame()
            }, frameDuration)
        }
        animate()
        mesh.layers.set(0);
        //scene.add(model)
        updateAllMaterials()
    }
)
const gltfLoader2 = new GLTFLoader()


gltfLoader2.load(
    '/models/room/model_1207.gltf',
    (gltf) =>
    {
        const model2 = gltf.scene.children[0]
        model2.position.set(-520, 80, 600)
        model2.rotation.z = 0
        

        const material_orther = new THREE.MeshBasicMaterial()
        material_orther.color = new THREE.Color('#7a7a7a')
       
        model2.traverse((child) => {
            if (child.isMesh) {
                // 移除原始材质
                child.material = material_orther
            }
        })

        // Create a mesh using the model and material
        const mesh_xishoupen = new THREE.Mesh(model2.geometry, material_orther);
        mesh_xishoupen.position.set(-300, 80, 300)
        mesh_xishoupen.scale.set(1, 1, 1)
        mesh_xishoupen.rotation.z = 1.5
        mesh_xishoupen.castShadow = false
        mesh_xishoupen.receiveShadow = false
        
        model2.layers.set(1);
        //scene.add(mesh_xishoupen)
        scene.add(model2)
        updateAllMaterials()
        
    }
)

const gltfLoader3 = new GLTFLoader()

gltfLoader3.load(  
    '/models/room/shafa.gltf',
    (gltf) => {
        const model3 = gltf.scene.children[0];
        model3.position.set(-300, 50, 70);
        model3.scale.set(0.5, 0.5, 0.5);
        model3.castShadow = false
        model3.receiveShadow = false
        model3.rotation.y = -1.5
    

        // Create a texture loader
        const textureLoader_shafa = new THREE.TextureLoader();

        // Load the color texture and alpha texture
        const colorTexture_shafa = textureLoader_shafa.load('/book_pattern_col1_500.png');
        const alphaTexture_shafa = textureLoader_shafa.load('models/transprant/trans_00046.jpg');

        // Create a material using the image sequence textures
        const material_shafa = new THREE.MeshBasicMaterial()
        material_shafa.transparent = true;
        material_shafa.alphaMap = alphaTexture_shafa;
        material_shafa.map = colorTexture_shafa;
        
        material_shafa.wrapS = THREE.RepeatWrapping
        material_shafa.wrapT = THREE.RepeatWrapping
        material_shafa.side = THREE.DoubleSide

        // model3.traverse((child) => {
        //     if (child.isMesh) {
        //         // 移除原始材质
        //         child.material = material_shafa
        //     }
        // })

        // Create a mesh using the model and material
        const mesh_shafa = new THREE.Mesh(model3.geometry, material_shafa);
        mesh_shafa.position.set(-300, 50, 70)
        mesh_shafa.scale.set(0.5, 0.5, 0.5)
        mesh_shafa.rotation.y = -1.5
        mesh_shafa.castShadow = false
        mesh_shafa.receiveShadow = false

        //scene.add(mesh_shafa);

        //scene.add(model3);
        updateAllMaterials();
    }
)

//wall
const gltfLoader4= new GLTFLoader()

gltfLoader4.load(  
    '/models/room/wall.gltf',
    (gltf) => {
        const model4 = gltf.scene.children[0];
        model4.position.set(-230, 130, 70);
        model4.scale.set(1, 1, 1);
        model4.castShadow = false
        model4.receiveShadow = false
        model4.rotation.y = -1.5
    

        // Create a texture loader
        const textureLoader_wall = new THREE.TextureLoader();
        // Define the image sequence URLs
        const WallAlphaImageSequenceUrls = [
            '/models/wall alpha/wall _alpha_00153.png',
            '/models/wall alpha/wall _alpha_00154.png',
            '/models/wall alpha/wall _alpha_00155.png',
            '/models/wall alpha/wall _alpha_00156.png',
            '/models/wall alpha/wall _alpha_00157.png',
            '/models/wall alpha/wall _alpha_00158.png',
            '/models/wall alpha/wall _alpha_00159.png',
            '/models/wall alpha/wall _alpha_00160.png',
            '/models/wall alpha/wall _alpha_00161.png',
            '/models/wall alpha/wall _alpha_00162.png',
            '/models/wall alpha/wall _alpha_00163.png',
            '/models/wall alpha/wall _alpha_00164.png',
            '/models/wall alpha/wall _alpha_00165.png',
            '/models/wall alpha/wall _alpha_00166.png',
            '/models/wall alpha/wall _alpha_00167.png',
            '/models/wall alpha/wall _alpha_00168.png',
            '/models/wall alpha/wall _alpha_00169.png',
            '/models/wall alpha/wall _alpha_00170.png',
            '/models/wall alpha/wall _alpha_00171.png',
            '/models/wall alpha/wall _alpha_00172.png',
            '/models/wall alpha/wall _alpha_00173.png',
            '/models/wall alpha/wall _alpha_00174.png',
            '/models/wall alpha/wall _alpha_00175.png',
            '/models/wall alpha/wall _alpha_00176.png',
            '/models/wall alpha/wall _alpha_00177.png',
            '/models/wall alpha/wall _alpha_00178.png',
            '/models/wall alpha/wall _alpha_00179.png',
            '/models/wall alpha/wall _alpha_00180.png',
            '/models/wall alpha/wall _alpha_00181.png',
            '/models/wall alpha/wall _alpha_00182.png',
            '/models/wall alpha/wall _alpha_00183.png',
            '/models/wall alpha/wall _alpha_00184.png',
            '/models/wall alpha/wall _alpha_00185.png',
            '/models/wall alpha/wall _alpha_00186.png',
            '/models/wall alpha/wall _alpha_00187.png',
            '/models/wall alpha/wall _alpha_00188.png',
            '/models/wall alpha/wall _alpha_00189.png',
            '/models/wall alpha/wall _alpha_00190.png',
            '/models/wall alpha/wall _alpha_00191.png',
            '/models/wall alpha/wall _alpha_00192.png',
            '/models/wall alpha/wall _alpha_00193.png',
            '/models/wall alpha/wall _alpha_00194.png',
            '/models/wall alpha/wall _alpha_00195.png',
            '/models/wall alpha/wall _alpha_00196.png',
            '/models/wall alpha/wall _alpha_00197.png',
            '/models/wall alpha/wall _alpha_00198.png',
            '/models/wall alpha/wall _alpha_00199.png',
            '/models/wall alpha/wall _alpha_00200.png',
            '/models/wall alpha/wall _alpha_00201.png',
            '/models/wall alpha/wall _alpha_00202.png',
            '/models/wall alpha/wall _alpha_00203.png',
            '/models/wall alpha/wall _alpha_00204.png',
            '/models/wall alpha/wall _alpha_00205.png',
            '/models/wall alpha/wall _alpha_00206.png',
            '/models/wall alpha/wall _alpha_00207.png',
            '/models/wall alpha/wall _alpha_00208.png',
            '/models/wall alpha/wall _alpha_00209.png',
            '/models/wall alpha/wall _alpha_00210.png',
            '/models/wall alpha/wall _alpha_00211.png',
            '/models/wall alpha/wall _alpha_00212.png',
            '/models/wall alpha/wall _alpha_00213.png',
            '/models/wall alpha/wall _alpha_00214.png',
            '/models/wall alpha/wall _alpha_00215.png',
            '/models/wall alpha/wall _alpha_00216.png',
            '/models/wall alpha/wall _alpha_00217.png',
            '/models/wall alpha/wall _alpha_00218.png',
            '/models/wall alpha/wall _alpha_00219.png',
            '/models/wall alpha/wall _alpha_00220.png',
            
            

            
            // Add more image URLs as needed
        ]

        // Create an array to store the textures
        const WallURLS = []

        // Load the image sequence textures
        WallAlphaImageSequenceUrls.forEach((imageUrl) => {
            const alphaTexture_wall = textureLoader_wall.load(imageUrl)
            WallURLS.push(alphaTexture_wall)
        })

        // Load the color texture and alpha texture
        const colorTexture_wall = textureLoader_wall.load('/wall color.png');

        // Create a material using the image sequence textures
        const material_wall = new THREE.MeshBasicMaterial
        material_wall.alphaMap = WallURLS[0]
        material_wall.transparent = true;
        material_wall.map = colorTexture_wall;
        material_wall.side = THREE.DoubleSide

        model4.traverse((child) => {
            if (child.isMesh) {
                // 移除原始材质
                child.material = material_wall
            }
        })

        // Create a mesh using the model and material
        const mesh_wall = new THREE.Mesh(model4.geometry, material_wall);
        mesh_wall.position.set(-230, 130, 70)
        mesh_wall.scale.set(1, 1, 1)
        mesh_wall.rotation.y = -1.5
        mesh_wall.castShadow = false
        mesh_wall.receiveShadow = false

        //scene.add(mesh_wall);

        // Animation variables
        let currentFrame = 0
        const frameRate = 30 // Number of frames per second
        const frameDuration = 1000 / frameRate // Duration of each frame in milliseconds

        // Function to update the texture frame
        const updateTextureFrame = () => {
            material_wall.alphaMap  = WallURLS[currentFrame]
            material_wall.needsUpdate = true
            currentFrame = (currentFrame + 1) % WallURLS.length
        }

        // Start the animation loop
        const animate = () => {
            setTimeout(() => {
                requestAnimationFrame(animate)
                updateTextureFrame()
            }, frameDuration)
        }
        animate()
        
        model4.layers.set(1);
        model4.renderOrder = 1
        scene.add(model4);
        updateAllMaterials();
    }
)
// //shafa2
// const gltfLoader5= new GLTFLoader()
// gltfLoader5.load(
//     '/models/room/shafa3.gltf',
//     (gltf) =>
//     {
//         const model5 = gltf.scene.children[0]
//         model5.position.set(-300, 50, 70)
//         model5.scale.set(0.5, 0.5, 0.5);
//         model5.castShadow = false
//         model5.receiveShadow = false
//         model5.rotation.y = -1.5

//         // const material_shafa2 = new THREE.MeshStandardMaterial()
//         // material_shafa2.transparent = true
//         // material_shafa2.color = new THREE.Color('#d1cec2')
       
//         // model5.traverse((child) => {
//         //     if (child.isMesh) {
//         //         // 移除原始材质
//         //         child.material = material_shafa2
//         //     }
//         // })
        
//         scene.add(model5)
//         updateAllMaterials()
        
//     }
// )

//guahua
const gltfLoader6= new GLTFLoader()
gltfLoader6.load(
    '/models/room/hua.gltf',
    (gltf) =>
    {
        const model6 = gltf.scene.children[0]
        model6.position.set(-260, 170, 50)
        model6.scale.set(1, 0.8, 1);
        model6.castShadow = false
        model6.receiveShadow = false
        model6.rotation.y = -1.5

        const material_hua = new THREE.MeshStandardMaterial()
        material_hua.transparent = true
        material_hua.color = new THREE.Color('#d1cec2')
       
        // model6.traverse((child) => {
        //     if (child.isMesh) {
        //         // 移除原始材质
        //         child.material = material_shafa2
        //     }
        // })
        model6.layers.set(1);
        scene.add(model6)
        updateAllMaterials()
        
    }
)

//zhuozi
const gltfLoader7= new GLTFLoader()
gltfLoader7.load(
    '/models/room/zhuozi.gltf',
    (gltf) =>
    {
        const model7 = gltf.scene.children[0]
        model7.position.set(-330, 0, -90)
        model7.scale.set(1, 1, 1);
        model7.castShadow = false
        model7.receiveShadow = false
        model7.rotation.y = -1.5

        const material_zhuozi = new THREE.MeshBasicMaterial()
        material_zhuozi.transparent = true
        material_zhuozi.color = new THREE.Color('#7a7a7a')
       
        model7.traverse((child) => {
            if (child.isMesh) {
                // 移除原始材质
                child.material = material_zhuozi
            }
        })
        model7.layers.set(1);
        scene.add(model7)
        updateAllMaterials()
        
    }
)

//shuiguo
const gltfLoader8= new GLTFLoader()
gltfLoader8.load(
    '/models/room/shuiguo.gltf',
    (gltf) =>
    {
        const model8 = gltf.scene.children[0]
        model8.position.set(-328, 48, 20)
        model8.scale.set(1, 1, 1);
        model8.castShadow = false
        model8.receiveShadow = false
        model8.rotation.y = -1.5

        const material_zhuozi = new THREE.MeshStandardMaterial()
        material_zhuozi.transparent = true
        material_zhuozi.color = new THREE.Color('#dedede')
       
        // model7.traverse((child) => {
        //     if (child.isMesh) {
        //         // 移除原始材质
        //         child.material = material_zhuozi
        //     }
        // })
        model8.layers.set(1);
        scene.add(model8)
        updateAllMaterials()
        
    }
)

//taideng
const gltfLoader9= new GLTFLoader()
gltfLoader9.load(
    '/models/room/taideng.gltf',
    (gltf) =>
    {
        const model9 = gltf.scene.children[0]
        model9.position.set(-310, 44, -100)
        model9.scale.set(1, 1, 1);
        model9.castShadow = false
        model9.receiveShadow = false
        model9.rotation.y = 0
        model9.rotation.z = -3.25
        

        const material_taideng= new THREE.MeshBasicMaterial()
        material_taideng.transparent = true
        material_taideng.color = new THREE.Color('#7a7a7a')
       
        model9.traverse((child) => {
            if (child.isMesh) {
                // 移除原始材质
                child.material = material_taideng
            }
        })
        
        material_taideng.castShadow = true
        material_taideng.receiveShadow = true
        scene.add(model9)
        model9.layers.set(0);
        updateAllMaterials()
        
    }
)

//bingxinag
const gltfLoader10= new GLTFLoader()
gltfLoader10.load(
    '/models/room/bingxiang.gltf',
    (gltf) =>
    {
        const model10 = gltf.scene.children[0]
        model10.position.set(50, 10, -180)
        model10.scale.set(1, 1, 1);
        model10.castShadow = false
        model10.receiveShadow = false
        model10.rotation.y = 1.1
        //model10.rotation.z = -3.5
        

        const material_taideng= new THREE.MeshBasicMaterial()
        material_taideng.transparent = true
        material_taideng.color = new THREE.Color('#7a7a7a')
       
        model10.traverse((child) => {
            if (child.isMesh) {
                // 移除原始材质
                child.material = material_taideng
            }
        })
        model10.layers.set(0);
        scene.add(model10)
        updateAllMaterials()
        
    }
)

//shafa3
const gltfLoader11= new GLTFLoader()
gltfLoader11.load(
    '/models/room/shafa4.gltf',
    (gltf) =>
    {
        const model11 = gltf.scene.children[0]
        model11.position.set(-300, 60, 70)
        model11.scale.set(0.5, 0.5, 0.5);
        model11.castShadow = false
        model11.receiveShadow = false
        model11.rotation.y = 3.25
        model11.rotation.z = 0
        model11.layers.set(1);
        model11.renderOrder = 2
        model11.depthWrite = false

        
        scene.add(model11)
        updateAllMaterials()
        
    }
)

//louban
const gltfLoader12= new GLTFLoader()
gltfLoader12.load(
    '/models/room/louban.gltf',
    (gltf) =>
    {
        const model12 = gltf.scene.children[0]
        model12.position.set(-300, -5, 570)
        model12.scale.set(0.5, 0.5, 0.5);
        model12.castShadow = false
        model12.receiveShadow = false
        model12.rotation.y = 4.75
        model12.rotation.z = 0
        model12.layers.set(1);
        const material_louban= new THREE.MeshBasicMaterial()
        material_louban.transparent = true
        material_louban.color = new THREE.Color('#999999')
       
        model12.traverse((child) => {
            if (child.isMesh) {
                // 移除原始材质
                child.material = material_louban
            }
        })

        
        scene.add(model12)
        updateAllMaterials()
        
    }
)

//beixin
const gltfLoader13= new GLTFLoader()
gltfLoader13.load(
    '/models/room/zhuozi.gltf',
    (gltf) =>
    {
        const model13 = gltf.scene.children[0]
        model13.position.set(-430, 0,100)
        model13.scale.set(1, 1, 1);
        model13.castShadow = false
        model13.receiveShadow = false
        model13.rotation.y = 0
        model13.rotation.z = 0
       
        const material_zhuozi = new THREE.MeshBasicMaterial()
        material_zhuozi.transparent = true
        material_zhuozi.color = new THREE.Color('#7a7a7a')
        
        model13.traverse((child) => {
            if (child.isMesh) {
                // 移除原始材质
                child.material = material_zhuozi
            }
        })

        scene.add(model13)
        updateAllMaterials()
        
    }
)
/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.4)
ambientLight.visible = true
ambientLight.layers.enable(0); // 将光源添加到第一层
ambientLight.layers.enable(1); // 将光源添加到第二层
scene.add(ambientLight)

const ambientLightFolder = gui.addFolder('Ambient Light')
ambientLightFolder.add(ambientLight, 'visible').name('On/Off')

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 300
directionalLight.shadow.camera.left = - 400
directionalLight.shadow.camera.top = 400
directionalLight.shadow.camera.right = 400
directionalLight.shadow.camera.bottom = - 400
directionalLight.position.set(-600, 300, 5)
//scene.add(directionalLight)

gui.add(directionalLight, 'intensity', 0, 1, 0.01)

const pointLight = new THREE.PointLight(0xffefc2, 0.6)
pointLight.shadow.mapSize.set(1024, 1024)
pointLight.shadow.camera.near = 1
pointLight.shadow.camera.far = 60000
pointLight.position.set(-500, 250, 5)
pointLight.castShadow = true
pointLight.layers.enable(1); // 将光源添加到第一层

scene.add(pointLight)

// Show point light helpers
// const pointLightHelper = new THREE.PointLightHelper(pointLight, 2)
// scene.add(pointLightHelper)

pointLightFolder.addColor(pointLight, 'color').onChange(() => {
    pointLight.color.set(pointLight.color)
})
pointLightFolder.add(pointLight, 'intensity', 0, 1, 0.01)
pointLightFolder.add(pointLight.position, 'x', - 500, 400, 0.01)
pointLightFolder.add(pointLight.position, 'y', 0, 300, 0.01)
pointLightFolder.add(pointLight.position, 'z', - 500, 400, 0.01)



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1))
})


/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1600)

camera.position.set(-550, 170, -80)
scene.add(camera)
camera.far = 10000
camera.layers.enable(0); // 将相机添加到第一层
camera.layers.enable(1); // 将相机添加到第二层

// // Keyboard controls
// const keyboard = {}

// window.addEventListener('keydown', (event) => {
//     keyboard[event.key] = true
// })dwwwwwww

// window.addEventListener('keyup', (event) => {
//     keyboard[event.key] = false
// })

// const moveCamera = () => {
//     const speed = 1

//     if (keyboard['a']) {
//         controls.target.x -= Math.sin(camera.rotation.y) * speed
//         controls.target.z -= Math.cos(camera.rotation.y) * speed
//     }

//     if (keyboard['d']) {
//         controls.target.x += Math.sin(camera.rotation.y) * speed
//         controls.target.z += Math.cos(camera.rotation.y) * speed
//     }

//     if (keyboard['w']) {
//         controls.target.x += Math.sin(camera.rotation.y + Math.PI / 2) * speed
//         controls.target.z += Math.cos(camera.rotation.y + Math.PI / 2) * speed
//     }

//     if (keyboard['s']) {
//         controls.target.x += Math.sin(camera.rotation.y - Math.PI / 2) * speed
//         controls.target.z += Math.cos(camera.rotation.y - Math.PI / 2) * speed
//     }
// }

// const moveCamera = () => {
//     const speed = 0.5

//     if (keyboard['d']) {
//         camera.position.x -= Math.sin(camera.rotation.y) * speed
//         camera.position.z -= Math.cos(camera.rotation.y) * speed
//     }

//     if (keyboard['a']) {
//         camera.position.x += Math.sin(camera.rotation.y) * speed
//         camera.position.z += Math.cos(camera.rotation.y) * speed
//     }

//     if (keyboard['w']) {
//         camera.position.x += Math.sin(camera.rotation.y + Math.PI / 2) * speed
//         camera.position.z += Math.cos(camera.rotation.y + Math.PI / 2) * speed
//     }

//     if (keyboard['s']) {
//         camera.position.x += Math.sin(camera.rotation.y - Math.PI / 2) * speed
//         camera.position.z += Math.cos(camera.rotation.y - Math.PI / 2) * speed
//     }
// }






/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputColorSpace = THREE.LinearSRGBColorSpace
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 20))

/**
 * post processing
 */
const effectComposer = new EffectComposer( renderer )
effectComposer.setSize(sizes.width, sizes.height)
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))  

const renderPass = new RenderPass( scene, camera )
effectComposer.addPass( renderPass )

const dotScreenPass = new DotScreenPass()
effectComposer.addPass(dotScreenPass)
dotScreenPass.scale = 10
dotScreenPass.enabled = false

const halftonePass = new HalftonePass( window.innerWidth, window.innerHeight, {
    shape: 1,
    radius: 4,
    rotateR: Math.PI / 12 * 0,
    rotateB: Math.PI / 12 * 2,
    rotateG: Math.PI / 12 * 4,
    scatter: 0,
    blending: 1,
    blendingMode: 1,
    greyscale: true ,
    disable: false
} )
effectComposer.addPass(halftonePass)
halftonePass.enabled = false


// // DOT SCREEN
// const dotScreenPass = new DotScreenPass()
// effectComposer.addPass(dotScreenPass)
// dotScreenPass.scale = 10
// dotScreenPass.enabled = false

folder3.add(dotScreenPass, 'enabled').name('dotScreenPass enabled')
folder3.add(dotScreenPass, 'scale').name('dotScreenPass scale').min(0).max(10).step(0.001)

// //harftone
// const halftonePass = new HalftonePass( window.innerWidth, window.innerHeight, {
//     shape: 1,
//     radius: 4,
//     rotateR: Math.PI / 12 * 0,
//     rotateB: Math.PI / 12 * 2,
//     rotateG: Math.PI / 12 * 4,
//     scatter: 0,
//     blending: 1,
//     blendingMode: 1,
//     greyscale: true,
//     disable: false
// } )
// effectComposer.addPass(halftonePass)
// halftonePass.enabled = false

folder4.add(halftonePass, 'enabled').name('halftonePass enabled')
folder4.add(halftonePass.uniforms.radius, 'value').name('halftonePass radius').min(0).max(10).step(0.001)
folder4.add(halftonePass.uniforms.rotateR, 'value').name('halftonePass rotateR').min(0).max(10).step(0.001)
folder4.add(halftonePass.uniforms.rotateB, 'value').name('halftonePass rotateB').min(0).max(10).step(0.001)
folder4.add(halftonePass.uniforms.rotateG, 'value').name('halftonePass rotateG').min(0).max(10).step(0.001)
folder4.add(halftonePass.uniforms.scatter, 'value').name('halftonePass scatter').min(0).max(10).step(0.001)


/**
 * Controls
    */  
const controls = new FirstPersonControls(camera, canvas)
controls.movementSpeed = 45
controls.noFly = true
controls.heightMax = 170
controls.heightMin = 170
controls.lookSpeed = 0.04
controls.lookVertical = true
controls.constrainVertical = true
controls.verticalMin = 1.5
controls.verticalMax = 3.14
controls.enabled = true
controls.mouseDragOn = true
controls.lookAt(400,80,600)

const fixedHeight = 170

gui.add(controls, 'movementSpeed', 0, 100, 0.1)
gui.add(controls, 'lookSpeed', 0, 1, 0.001)
gui.add(controls, 'lookVertical', true)
gui.add(controls, 'constrainVertical', true)
gui.add(controls, 'verticalMin', 0, Math.PI, 0.1)
gui.add(controls, 'verticalMax', 0, Math.PI, 0.1)
gui.add(controls, 'enabled', true)

const lookAtButton = {
    lookAt: function() {
        const target = new THREE.Vector3(-25, 10, 50);
        controls.lookAt(target); // Look at the target
        controls.enabled = false;

    }
}
gui.add(lookAtButton, 'lookAt')

const unlockButton = {
    unlock: function() {
        controls.enabled = true;
    }
}

gui.add(unlockButton, 'unlock');

/**
 * shadow   
 * 
 */
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
pointLight.shadow.radius = 5


//target    

// Helper
// const pointLightCameraHelper = new THREE.CameraHelper(pointLight.shadow.camera)
// scene.add(pointLightCameraHelper)
// const directionalLightCameraHelper = new THREE.CameraHelper(directionalLight.shadow.camera)
// scene.add(directionalLightCameraHelper)

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Update controls
    //controls.update()
    controls.update(deltaTime)
    // // Move camera
    camera.position.y = fixedHeight

    // moveCamera()

    // Render
    renderer.render(scene, camera)

    //post processing
    effectComposer.render()

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()